import Drawer from '@mui/material/Drawer';
import Box from '@mui/material/Box';

const DrawerComponent = ({ isOpen, toggleDrawer, children }) => {

  const stopPropagation = (event) => {
    event.stopPropagation();
  };

  const handleClose = (event) => {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
      return;
    }
    toggleDrawer(false)(event);
  };

  return (
    <div>
      <Drawer anchor="right" open={isOpen} onClose={handleClose}>
        <Box
          sx={{ width: 'min(900px, 100vw)', padding: { xs: 0, sm: 2 } }}
          role="presentation"
          onClick={stopPropagation}
          onKeyDown={stopPropagation}
        >
          {children}
        </Box>
      </Drawer>
    </div>
  );
};

export default DrawerComponent;
